
          import { defineNuxtPlugin } from "#imports";

          export default defineNuxtPlugin({
            name: 'sentry-client-config',
            async setup() {
              await import("/baserow-saas/baserow/web-frontend/sentry.client.config.ts")
            }
          });